export default __webpack_public_path__ + "static/media/xmark.92b3951f.svg";